import React from 'react';
import { Card, Typography, Tag, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from 'react-router-dom';
import './index.css'; 

const { Title, Text } = Typography;

const PostDetail = ({ article, onClose, showBackButton = false }) => {
  const navigate = useNavigate();
  const { id } = useParams();

  const handleBack = () => {
    if (onClose) {
      onClose();
    } else {
      navigate('/archive');
    }
  };

  if (!article) {
    return (
      <div className="post-detail-card">
        <p>文章未找到</p>
      </div>
    );
  }

  return (
    <Card 
      className="post-detail-card"
      style={{ margin: '40px auto', maxWidth: '800px', width: '90%' }}
    >
      {showBackButton && (
        <Button 
          type="text" 
          icon={<ArrowLeftOutlined />} 
          onClick={handleBack}
          style={{ marginBottom: 16 }}
        >
          返回文章列表
        </Button>
      )}
      
      <Title level={2}>{article.title}</Title>
      
      <div className="article-detail-meta">
        <Text type="secondary">{article.date}</Text>
        <span className="meta-divider">•</span>
        <Text type="secondary">作者: {article.author}</Text>
        <div className="article-tags">
          {article.tags?.map((tag, index) => (
            <Tag key={index} color="blue" className="article-tag">
              {tag}
            </Tag>
          ))}
        </div>
      </div>
      
      <div className="article-detail-content">
        <Text>{article.content}</Text>
      </div>
    </Card>
  );
};

export default PostDetail;